<!--
  A LoadingIndicator that is displayed while a promise is on-flight.
-->
<script setup lang="ts">import { ref as _ref, toRef as _toRef } from 'vue';
const __props_loadingUntil = _toRef(__props, 'loadingUntil');

withDefaults(defineProps<{ loadingUntil: Promise<unknown> | undefined }>(), {  })

let displayLoadingIndicator = _ref(Boolean(__props.loadingUntil))

watch((__props_loadingUntil), () => {
  if (__props.loadingUntil) displayLoadingIndicator.value = true
  handleLoadingUntil()
})

onMounted(handleLoadingUntil)

function handleLoadingUntil () {
  __props.loadingUntil?.finally(() => { displayLoadingIndicator.value = false })
}
</script>

<template>
  <XLoadingIndicator v-if="displayLoadingIndicator" size="sm"/>
</template>
